<template>
    <div class="set">
        <div class="set-inner">
            <Header :title="set.name"
                    :info="productView ? '' : $tc('photos_selected_amount', set.products.length, {amount: set.products.length})"
                    :fullscreen="fullscreen"
                    :view-product="productView"
                    @close-order-set="closeOrderSet"
                    @view-product="viewProduct"
                    @handle-fullscreen="fullscreen = $event"/>
            <main>
                <step-1-change-photo v-if="photosView" :fullscreen="fullscreen"/>
                <step-1-view-product v-else-if="productView" :fullscreen="fullscreen" :view-product="productView"/>
                <step-1 v-else :set-products="setProducts" @view-product="viewProduct"/>
            </main>
            <Footer :photos-view="photosView"
                    :fullscreen="fullscreen"
                    :set-products="setProducts"
                    :view-product="productView"
                    @close-order-set="closeOrderSet"
                    @view-product="viewProduct"
                    @handle-fullscreen="fullscreen = $event"/>
        </div>
    </div>
</template>

<style lang="scss">
    .set {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        overflow-y: auto;
        background-color: var(--bg-secondary-color);
        z-index: 4;

        &-inner {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            min-height: 100%;

            > main {
                position: relative;
                width: 100%;
                flex-grow: 1;
                display: flex;
                justify-content: center;
                height: calc(100vh - 200px);
                overflow-y: auto;
            }
        }
    }

    body.-is-mobile {

        .set {
            padding: 100px 0 80px;

            &-inner > main {
                position: relative;
                padding-bottom: 85px;
                max-height: 100%;
            }

            #backBtn {
                position: fixed;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 40px;
                height: 40px;
                left: 20px;
                bottom: 100px;
                padding: 0;
                border-radius: 50%;
                box-shadow: 0 2px 13px rgba(#000, .1), 0 8px 22px rgba(#000, .15);
                z-index: 1;

                .material-icon {
                    position: relative;
                    left: 1.5px;
                    font-size: 2rem !important;
                }
            }

            #nextBtn {
                position: fixed;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 60px;
                height: 60px;
                margin: 0;
                right: 20px;
                bottom: 50px;
                border-radius: 50%;
                z-index: 3;

                .material-icon {
                    margin: 0;
                    font-size: 1.6rem !important;
                }
            }
        }
    }
</style>

<script>
  import Header from './set/partials/Header.vue';
  import Footer from './set/partials/Footer.vue';

  import Step1 from './set/Step1.vue';
  import Step1ChangePhoto from './set/Step1ChangePhoto.vue';
  import Step1ViewProduct from './set/Step1ViewProduct.vue';

  import set from 'src/mixins/setComponent';

  export default {
    mixins: [set],
    components: {
      Header,
      Footer,
      Step1,
      Step1ChangePhoto,
      Step1ViewProduct,
    },
  };
</script>
